import { createFileRoute, Outlet } from '@tanstack/react-router';

// RUF-540: no beforeLoad gate — the Assets nav item and route always render.
// Locked-vs-unlocked is decided per-page (see routes/assets/index.tsx), not
// at this layout level, so an incomplete seller profile shows the locked
// card instead of bouncing the whole /assets subtree to the dashboard.
export const Route = createFileRoute('/assets')({
  component: () => <Outlet />,
});
